var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"m-0 text-2xl font-semibold leading-tight tracking-tight border-solid md:text-4xl"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }